import React, { useEffect, useState } from 'react';
import API from '../api';
import { toast } from 'react-hot-toast';

export default function WIMTruckTypes() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ code: '', name_lao: '', wheels: '', axles: '', legal_weight_kg: '', active: true });
  const [editingId, setEditingId] = useState(null);

  const load = async () => {
    try {
      const res = await API.get('/wim/truck-types');
      setItems(res.data);
    } catch (e) {
      toast.error('ດຶງຂໍ້ມູນປະເພດລົດບໍ່ສໍາເລັດ');
    } finally {
      setLoading(false);
    }
  };

  useEffect(()=>{ load(); },[]);

  const seed = async () => {
    try {
      await API.post('/wim/truck-types/seed-lao');
      toast.success('ໂຫຼດປະເພດລາວສໍາເລັດ');
      load();
    } catch {
      toast.error('ໂຫຼດລາຍການບໍ່ສໍາເລັດ');
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const payload = { ...form };
    // normalize numbers
    ['wheels','axles','legal_weight_kg'].forEach(k => { if (payload[k] !== '' && payload[k] != null) payload[k] = parseInt(String(payload[k]).replace(/,/g,'')); else payload[k] = null; });
    try {
      if (editingId) {
        await API.put(`/wim/truck-types/${editingId}`, payload);
        toast.success('ອັບເດດສໍາເລັດ');
      } else {
        await API.post('/wim/truck-types', payload);
        toast.success('ບັນທຶກສໍາເລັດ');
      }
      setForm({ code: '', name_lao: '', wheels: '', axles: '', legal_weight_kg: '', active: true });
      setEditingId(null);
      load();
    } catch (e2) {
      toast.error('ບັນທຶກ/ອັບເດດລົ້ມເຫຼວ');
    }
  };

  const removeItem = async (it) => {
    if (!window.confirm('ຢືນຢັນລົບ?')) return;
    try {
      await API.delete(`/wim/truck-types/${it.id}`);
      load();
    } catch {
      toast.error('ລົບບໍ່ສໍາເລັດ');
    }
  };

  const toggleActive = async (it) => {
    try {
      await API.put(`/wim/truck-types/${it.id}`, { ...it, active: !it.active });
      load();
    } catch {
      toast.error('ປຽນສະຖານະບໍ່ສໍາເລັດ');
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">🚚 ປະເພດລົດບັນທຸກ ແລະ ນ້ຳໜັກມາດຕະຖານ</h1>
        <button onClick={seed} className="bg-indigo-600 hover:bg-indigo-700 text-white py-1 px-3 rounded">ໂຫຼດຕາຕະລາງລາວ</button>
      </div>

      <div className="bg-white dark:bg-gray-700 p-4 rounded-lg border">
        <h2 className="text-lg font-semibold mb-3">ເພີ່ມ/ແກ້ໄຂ ປະເພດລົດບັນທຸກ</h2>
        <form onSubmit={onSubmit} className="grid grid-cols-1 md:grid-cols-5 gap-3 mb-4">
          <input className="p-2 border rounded" placeholder="ລະຫັດ (ເຊັ່ນ TR06)" value={form.code} onChange={e=>setForm({...form,code:e.target.value})} />
          <input className="p-2 border rounded" placeholder="ຊື່ (ລາວ)" value={form.name_lao} onChange={e=>setForm({...form,name_lao:e.target.value})} />
          <input className="p-2 border rounded" placeholder="ຈໍານວນລໍ້" value={form.wheels} onChange={e=>setForm({...form,wheels:e.target.value})} />
          <input className="p-2 border rounded" placeholder="ເພົາ" value={form.axles} onChange={e=>setForm({...form,axles:e.target.value})} />
          <input className="p-2 border rounded" placeholder="ນ້ໍາໜັກມາດຕະຖານ (Kg)" value={form.legal_weight_kg} onChange={e=>setForm({...form,legal_weight_kg:e.target.value})} />
          <div className="md:col-span-5 flex gap-2">
            <button type="submit" className="bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded">{editingId ? 'ອັບເດດ' : 'ບັນທຶກ'}</button>
            {editingId && (
              <button type="button" onClick={()=>{ setEditingId(null); setForm({ code:'', name_lao:'', wheels:'', axles:'', legal_weight_kg:'', active:true }); }} className="bg-gray-500 hover:bg-gray-600 text-white py-2 px-4 rounded">ຍົກເລີກ</button>
            )}
          </div>
        </form>
        <div className="overflow-auto">
          <table className="min-w-full text-sm">
            <thead>
              <tr className="text-left border-b">
                <th className="p-2">ລະຫັດ</th>
                <th className="p-2">ຊື່ (ລາວ)</th>
                <th className="p-2">ລໍ້</th>
                <th className="p-2">ເພົາ</th>
                <th className="p-2">ນ້ໍາໜັກມາດຕະຖານ (Kg)</th>
                <th className="p-2">ສະຖານະ</th>
                <th className="p-2">ຈັດການ</th>
              </tr>
            </thead>
            <tbody>
              {items.map(it => (
                <tr key={it.id} className="border-b">
                  <td className="p-2">{it.code}</td>
                  <td className="p-2">{it.name_lao}</td>
                  <td className="p-2">{it.wheels}</td>
                  <td className="p-2">{it.axles}</td>
                  <td className="p-2">{Number(it.legal_weight_kg).toLocaleString()}</td>
                  <td className="p-2">{it.active ? <span className="px-2 py-1 rounded-full text-xs bg-green-100 text-green-700">ໃຊ້ງານ</span> : <span className="px-2 py-1 rounded-full text-xs bg-amber-100 text-amber-700">ປິດ</span>}</td>
                  <td className="p-2 flex gap-2">
                    <button onClick={()=>{ setEditingId(it.id); setForm({ code: it.code||'', name_lao: it.name_lao||'', wheels: it.wheels||'', axles: it.axles||'', legal_weight_kg: it.legal_weight_kg||'', active: !!it.active }); }} className="px-3 py-1 rounded bg-blue-600 hover:bg-blue-700 text-white">ແກ້ໄຂ</button>
                    <button onClick={()=>toggleActive(it)} className={`px-3 py-1 rounded ${it.active?'bg-amber-500 hover:bg-amber-600':'bg-green-600 hover:bg-green-700'} text-white`}>{it.active?'ປິດໃຊ້':'ເປີດໃຊ້'}</button>
                    <button onClick={()=>removeItem(it)} className="px-3 py-1 rounded bg-red-600 hover:bg-red-700 text-white">ລົບ</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
